import axios from 'axios';
import { API_GUEST_UPDATE_NAME, API_JOIN_GUEST, API_MAP, API_VMP_GET_USER_BY_TOKEN, API_VMP_LOGOUT } from '../../../modules/API/route';
import axiosClient from './axiosClient';
class ApiManagerUser {
    constructor() {
        this.guestJoin = (name = '') => {
            return axios.get(`${API_JOIN_GUEST}?name=${name}`);
        };
        this.guestUpdateName = (data) => {
            return axiosClient.post(API_GUEST_UPDATE_NAME, data);
        };
        this.getUserByToken = () => {
            return axiosClient.get(API_VMP_GET_USER_BY_TOKEN);
        };
        this.checkGuestAccount = (userId) => {
            return axiosClient.get(`${API_MAP.USER.CHECK_GUEST_ACCOUNT}?userId=${userId}`);
        };
        this.updateDisplayname = (data) => {
            return axiosClient.post(API_MAP.USER.UPDATE_DISPLAYNAME, data);
        };
        this.getUserFunctions = () => {
            return axiosClient.get(API_MAP.USER.GET_USER_FUNCTIONS);
        };
        this.logout = () => {
            return axiosClient.post(API_VMP_LOGOUT, {});
        };
        this.getVPQHRefreshtoken = (data) => {
            return axiosClient.post(API_MAP.AUTH.VPQH_SSO, data);
        };
        this.getClientRefreshtoken = (clientName, data) => {
            return axiosClient.post(`${API_MAP.AUTH.SSO}/${clientName}`, data);
        };
    }
}
export default new ApiManagerUser();
